/* eslint-disable */
import Vue from 'vue'

const indicativeScript = {
  is_mounted: false,
  init: (key, cb) => {
    (function(apiKey,callback) { var ind = document.createElement('script'); ind.src = '//cdn.indicative.com/js/Indicative.min.js'; ind.type = 'text/javascript'; ind.async = 'true'; var ind_init = false; ind.onload = ind.onreadystatechange = function() { var rs = this.readyState; if (ind_init || (rs && rs != 'complete' && rs != 'loaded')) return; ind_init = true; Indicative.initialize(apiKey, {recordSessions: true, sessionsThreshold: 15, cookiesOnMainDomain: false }); Indicative.buildEvent('Page View'); callback(Indicative)}; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ind, s); })
    (key,cb);
  }
}

const install = function (Vue, options = {}) {
  if (install.installed) return false

  let indicativeCalls = [];

  Vue.prototype.$indicative = (func) => {
    if (indicativeScript.is_mounted) {
      func(Indicative);
    } else {
      indicativeCalls.push(func);
    }
   }

  if (options.key === undefined || options.key === null) {
    if (process?.env?.indicativeApiKey !== 'undefined' ) {
      options.key = process.env.indicativeApiKey
    }
  }
  if (indicativeScript.is_mounted === false) {
    indicativeScript.init(options.key, function (ind) {
      indicativeScript.is_mounted = true;
      // lets process all queued calls;
      for (let i = 0; i < indicativeCalls.length; i++) {
        indicativeCalls[i](Indicative);
      }
    })
  }

}

const indicativePlugin = {
  install
}

Vue.use(indicativePlugin)
